/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfigurationFormMetadata
 */
export interface ConfigurationFormMetadata {
    /**
     * 
     * @type {string}
     * @memberof ConfigurationFormMetadata
     */
    taskId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigurationFormMetadata
     */
    workAccess?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigurationFormMetadata
     */
    isPmkTask?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationFormMetadata
     */
    taskName?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationFormMetadata
     */
    techId?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationFormMetadata
     */
    stepMetadataType: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationFormMetadata
     */
    schemaUuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationFormMetadata
     */
    schema?: string;
}

/**
 * Check if a given object implements the ConfigurationFormMetadata interface.
 */
export function instanceOfConfigurationFormMetadata(value: object): value is ConfigurationFormMetadata {
    if (!('stepMetadataType' in value) || value['stepMetadataType'] === undefined) return false;
    return true;
}

export function ConfigurationFormMetadataFromJSON(json: any): ConfigurationFormMetadata {
    return ConfigurationFormMetadataFromJSONTyped(json, false);
}

export function ConfigurationFormMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationFormMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'workAccess': json['workAccess'] == null ? undefined : json['workAccess'],
        'isPmkTask': json['isPmkTask'] == null ? undefined : json['isPmkTask'],
        'taskName': json['taskName'] == null ? undefined : json['taskName'],
        'techId': json['techId'] == null ? undefined : json['techId'],
        'stepMetadataType': json['stepMetadataType'],
        'schemaUuid': json['schemaUuid'] == null ? undefined : json['schemaUuid'],
        'schema': json['schema'] == null ? undefined : json['schema'],
    };
}

export function ConfigurationFormMetadataToJSON(json: any): ConfigurationFormMetadata {
    return ConfigurationFormMetadataToJSONTyped(json, false);
}

export function ConfigurationFormMetadataToJSONTyped(value?: ConfigurationFormMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskId': value['taskId'],
        'workAccess': value['workAccess'],
        'isPmkTask': value['isPmkTask'],
        'taskName': value['taskName'],
        'techId': value['techId'],
        'stepMetadataType': value['stepMetadataType'],
        'schemaUuid': value['schemaUuid'],
        'schema': value['schema'],
    };
}

